import React, { useState, useEffect, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TwoButtons from '../components/twoButtons';
import WineA from '../images/wine-a.png';
import WineB from '../images/wine-b.png';
import WineC from '../images/wine-c.png';
import WineD from '../images/wine-d.png';
import close from '../images/close-stats.png';
import points from '../images/puntuacion.webp';
export default function ChooseComponent() {
    const [testsData, setTestsData] = useState([]);
    const [answersData, setAnswersData] = useState([]);
    const [profileInfo, setProfileInfo] = useState({ id: 0 });
    const [isSubmitPopupVisible, setSubmitPopupVisible] = useState(false);
    const [isHelpPopupVisible, setHelpPopupVisible] = useState(false);
    const navigate = useNavigate();
   

    useEffect(() => {
        // Cargar la información del usuario desde localStorage
        const storedUserInfo = localStorage.getItem('userLogged');
        if (storedUserInfo) {
            const userInfo = JSON.parse(storedUserInfo);
            console.log(userInfo);
            setProfileInfo(userInfo);
        }
    }, []);
    const closeSubmitPopup = () => {
        setSubmitPopupVisible(false);
    }; 
    const getTests = () => {
        if (profileInfo && profileInfo.id) {
            const xhr = new XMLHttpRequest();
            const url = `${process.env.REACT_APP_API_URL}/getAnswers/${profileInfo.id}`;
            xhr.open("GET", url, true);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        const data = JSON.parse(xhr.responseText);
                        setTestsData(data.tests);
                        setAnswersData(data.answers);
                        console.log(data);


                    } else if (xhr.status === 204) {
                    }
                }
            };
            xhr.send();
        }
    };
    const calculateTotalPoints = (answer) => {
        return (
            (answer.visual || 0) +
            (answer.olfactory || 0) +
            (answer.taste || 0) +
            (answer.variety || 0) +
            (answer.price || 0)
        );
    };
    useEffect(() => {
        if (profileInfo && profileInfo.id) { // Añadido check para asegurar que profileInfo tiene un id
            getTests();
        }
    }, [profileInfo]);

    const handleWineClick = (e, wineTitle) => {
        const selectedTest = [...testsData].reverse().find(test => test.title === wineTitle);
        if (selectedTest) {
            const selectedAnswer = answersData.find(answer => Number(answer.test_id) === Number(selectedTest.id));

            if (selectedAnswer && selectedAnswer.object) {
                localStorage.setItem('currentTest', JSON.stringify(selectedTest));
                localStorage.setItem('currentAnswer', JSON.stringify(selectedAnswer.object));
            } else {
                e.preventDefault(); // Previene la navegación si la respuesta no está disponible o es inválida
            }
        } else {
            e.preventDefault(); // Previene la navegación si el test no está disponible
        }
    };

    const closeHelpPopup = () => {
        setHelpPopupVisible(false);
    };

    const handleHelpClick = () => {
            setHelpPopupVisible(true);
    };

    const openNewTab = () => {
        window.open('http://www.encopadebalon.com', '_blank');
    };

    const isWineDisabled = (wineTitle) => {
        return !testsData.some(test => test.title === wineTitle);
    };

    return (
        <div className="test-container">
            <div className="slider-container">
                <div className="slide-container">
                    <h2 className="">Tus últimas respuestas</h2>
                    <div className="choose-wine-container">
                        <Link 
                            to="/answer" 
                            className={`image-link ${isWineDisabled('A') ? 'disabled' : ''}`}
                            onClick={(e) => handleWineClick(e, 'A')}
                        >
                            <span>A</span>
                            {testsData.some(test => test.title === 'A') && (() => {
                                const testA = [...testsData].reverse().find(test => test.title === 'A');
                                const answerA = answersData.find(answer => answer.test_id == testA.id);

                                return answerA ? (
                                    <span className="answer-points">{calculateTotalPoints(answerA)} pts</span>
                                ) : null;
                            })()}


                        </Link>
                        <Link 
                            to="/answer" 
                            className={`image-link ${isWineDisabled('B') ? 'disabled' : ''}`}
                            onClick={(e) => handleWineClick(e, 'B')}
                        >
                            <span>B</span>
                            {testsData.some(test => test.title === 'B') && (() => {
                                const testA = testsData.find(test => test.title === 'B');
                                const answerA = answersData.find(answer => answer.test_id == testA.id);

                                return answerA ? (
                                    <span className="answer-points">{calculateTotalPoints(answerA)} pts</span>
                                ) : null;
                            })()}
                        </Link>
                        <Link 
                            to="/answer" 
                            className={`image-link ${isWineDisabled('C') ? 'disabled' : ''}`}
                            onClick={(e) => handleWineClick(e, 'C')}
                        >
                            <span>C</span>
                            {testsData.some(test => test.title === 'C') && (() => {
                                const testA = testsData.find(test => test.title === 'C');
                                const answerA = answersData.find(answer => answer.test_id == testA.id);

                                return answerA ? (
                                    <span className="answer-points">{calculateTotalPoints(answerA)} pts</span>
                                ) : null;
                            })()}
                        </Link>
                        <Link 
                            to="/answer" 
                            className={`image-link ${isWineDisabled('D') ? 'disabled' : ''}`}
                            onClick={(e) => handleWineClick(e, 'D')}
                        >
                            <span>D</span>
                            {testsData.some(test => test.title === 'D') && (() => {
                                const testA = testsData.find(test => test.title === 'D');
                                const answerA = answersData.find(answer => answer.test_id == testA.id);

                                return answerA ? (
                                    <span className="answer-points">{calculateTotalPoints(answerA)} pts</span>
                                ) : null;
                            })()}
                        </Link>
                        <Link 
                            to="/answer" 
                            className={`image-link ${isWineDisabled('E') ? 'disabled' : ''}`}
                            onClick={(e) => handleWineClick(e, 'E')}
                        >
                            <span>E</span>
                            {testsData.some(test => test.title === 'E') && (() => {
                                const testA = testsData.find(test => test.title === 'E');
                                const answerA = answersData.find(answer => answer.test_id == testA.id);

                                return answerA ? (
                                    <span className="answer-points">{calculateTotalPoints(answerA)} pts</span>
                                ) : null;
                            })()}
                        </Link>
                        <Link 
                            to="/answer" 
                            className={`image-link ${isWineDisabled('F') ? 'disabled' : ''}`}
                            onClick={(e) => handleWineClick(e, 'F')}
                        >
                            <span>F</span>
                            {testsData.some(test => test.title === 'F') && (() => {
                                const testA = testsData.find(test => test.title === 'F');
                                const answerA = answersData.find(answer => answer.test_id == testA.id);

                                return answerA ? (
                                    <span className="answer-points">{calculateTotalPoints(answerA)} pts</span>
                                ) : null;
                            })()}
                        </Link>
                    </div>
                    
                </div>
            </div>
            <TwoButtons onHelp={handleHelpClick} />
            {isSubmitPopupVisible && (
                <Popup
                    text="No hay ningún juego activo. Cierra esta ventana y haz clic en las botellas para ver si los resultados están disponibles. Si no están iluminadas, aún no se han publicado."
                    onClose={closeSubmitPopup}
                    isHelpPopup={false}
                />
            )}
            {isHelpPopupVisible && (
                <Popup
                    imageUrl={points}
                    onClose={closeHelpPopup}
                    isHelpPopup={true}
                />
            )}
        </div>
    );
};
const Popup = ({ text, onClose, onConfirm, imageUrl, isHelpPopup }) => {
    return (
        <div className="custom-overlay">
            <div className={`custom-popup ${isHelpPopup ? 'popup-noback' : ''}`}>
                <button className="stats-close" onClick={onClose}><img src={close} alt="close" /></button>
                {text && <p>{text}</p>}
                {imageUrl && (
                    <div className="image-container">
                        <img src={imageUrl} alt="Ayuda" />
                    </div>
                )}
                {onConfirm && <button onClick={onConfirm}>Enviar</button>}
            </div>
        </div>
    );
};